import React, { useEffect, useState } from 'react';

const defaultPlans = [
  {
    id: 'plano-cortes-barba',
    badgeTitle: 'Completo',
    title: 'Plano de Cortes e Barba',
    price: 'Consulte o valor vigente no aplicativo',
    features: [
      'Cortes inclusos',
      'Serviços de barba inclusos',
      'Uso gratuito dos serviços inclusos no plano'
    ],
    validityText: 'Válido de segunda a sexta-feira',
    remainingSlots: null
  },
  {
    id: 'plano-cortes',
    badgeTitle: null,
    title: 'Plano de Cortes',
    price: 'Consulte o valor vigente no aplicativo',
    features: [
      'Cortes inclusos',
      'Uso gratuito dos serviços inclusos no plano'
    ],
    validityText: 'Válido de segunda a sexta-feira',
    remainingSlots: null
  }
];

function ClubeFiladelfoTerms() {
  const [plans, setPlans] = useState(defaultPlans);
  const [plansStatus, setPlansStatus] = useState('idle');

  useEffect(() => {
    if (typeof fetch !== 'function') {
      return;
    }

    let isMounted = true;

    async function loadPlans() {
      setPlansStatus('loading');

      try {
        const response = await fetch('https://barbeariafiladelfo.com.br/api/v2/subscription/plans');

        if (!response.ok) {
          throw new Error('Nao foi possivel carregar os planos.');
        }

        const data = await response.json();

        if (isMounted) {
          setPlans(Array.isArray(data) && data.length > 0 ? data : defaultPlans);
          setPlansStatus('success');
        }
      } catch (error) {
        if (isMounted) {
          setPlans(defaultPlans);
          setPlansStatus('error');
        }
      }
    }

    loadPlans();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="legal-page clube-terms">
      <section className="legal-hero">
        <p className="eyebrow">Clube Filadelfo</p>
        <h1>Termos da Assinatura Clube Filadelfo</h1>
        <p>
          Estes termos regulam a contratação, uso, cobrança e cancelamento dos
          planos de assinatura oferecidos pela Barbearia Filadelfo.
        </p>
        <p className="last-updated">Última atualização: 29 de agosto de 2026</p>
      </section>

      <section className="legal-section">
        <h2>1. Objeto da assinatura</h2>
        <p>
          O Clube Filadelfo é uma assinatura recorrente destinada exclusivamente
          ao uso de serviços físicos presenciais, realizados no estabelecimento da
          Barbearia Filadelfo. Os benefícios do plano se referem somente a
          atendimentos presenciais de barbearia, como cortes e barba, conforme os
          serviços inclusos no plano contratado.
        </p>
        <p>
          A assinatura não inclui conteúdo digital, produto virtual, crédito
          digital, moeda virtual, item consumível no aplicativo, funcionalidade
          premium digital ou qualquer outro benefício virtual. O aplicativo é
          utilizado apenas como meio de cadastro, gestão da assinatura e
          agendamento facilitado e gratuito dos atendimentos físicos inclusos no
          plano.
        </p>
        <p>
          A assinatura também não representa compra antecipada de créditos, saldo
          em dinheiro, pacote transferível ou garantia de atendimento fora das
          condições do plano.
        </p>
      </section>

      <section className="legal-section">
        <div className="section-heading-row">
          <h2>2. Planos disponíveis</h2>
          {plansStatus === 'loading' && <span>Atualizando planos...</span>}
        </div>
        <p>
          Os planos abaixo podem variar conforme disponibilidade, preço vigente,
          limites de vagas e condições publicadas no aplicativo.
        </p>

        {plansStatus === 'error' && (
          <p className="status-note">
            Não foi possível carregar os dados atualizados dos planos agora. As
            informações abaixo servem como referência, e as condições vigentes
            devem ser confirmadas no aplicativo no momento da contratação.
          </p>
        )}

        <div className="plans-grid">
          {plans.map((plan) => (
            <article className="plan-card" key={plan.id || plan.title}>
              {plan.badgeTitle && <p className="plan-badge">{plan.badgeTitle}</p>}
              <h3>{plan.title}</h3>
              <p className="plan-price">{plan.price}</p>
              <p className="plan-validity">{plan.validityText}</p>
              <ul>
                {(plan.features || []).map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <p className="plan-slots">
                {plan.remainingSlots === null || plan.remainingSlots === undefined
                  ? 'Vagas conforme disponibilidade do clube.'
                  : plan.remainingSlots > 0
                    ? `${plan.remainingSlots} vaga(s) restante(s).`
                    : 'Plano sem vagas disponíveis no momento.'}
              </p>
            </article>
          ))}
        </div>
      </section>

      <section className="legal-section">
        <h2>3. Beneficiário e CPF vinculado</h2>
        <p>
          Cada assinatura é pessoal, individual e vinculada a um único CPF. Apenas
          o beneficiário direto cadastrado no plano poderá utilizar os serviços
          inclusos, sendo vedado compartilhar, transferir, revender ou permitir o
          uso por terceiros, familiares, amigos ou acompanhantes.
        </p>
        <p>
          A Barbearia Filadelfo poderá solicitar confirmação de identidade antes do
          atendimento para preservar a segurança da assinatura e evitar uso
          indevido.
        </p>
      </section>

      <section className="legal-section">
        <h2>4. Serviços inclusos e dias de uso</h2>
        <p>
          O assinante poderá utilizar gratuitamente apenas os serviços listados na
          categoria do plano contratado. O Plano de Cortes e Barba contempla os
          serviços de corte e barba previstos no plano. O Plano de Cortes contempla
          apenas os serviços de corte previstos no plano.
        </p>
        <p>
          O uso dos benefícios é permitido somente de segunda a sexta-feira,
          conforme disponibilidade de agenda da unidade. Os benefícios da assinatura
          não são válidos aos sábados, domingos, feriados ou datas bloqueadas pela
          Barbearia Filadelfo.
        </p>
      </section>

      <section className="legal-section">
        <h2>5. Agendamentos gratuitos</h2>
        <p>
          A assinatura não permite que o beneficiário mantenha mais de um
          agendamento gratuito simultaneamente. Para realizar novo agendamento
          gratuito, é necessário concluir, cancelar ou remarcar o atendimento
          gratuito já existente, respeitando as regras do aplicativo.
        </p>
        <p>
          O agendamento depende de horários disponíveis. A contratação do plano não
          garante vaga em horário, profissional ou data específica.
        </p>
      </section>

      <section className="legal-section">
        <h2>6. Cobrança e renovação automática</h2>
        <p>
          Após a contratação, a cobrança será feita automaticamente no meio de
          pagamento escolhido pelo usuário, de forma recorrente, até que a assinatura
          seja cancelada pelo assinante ou encerrada conforme estes termos.
        </p>
        <p>
          No vencimento da cobrança, caso a renovação falhe por recusa, ausência de
          saldo, cartão expirado, inconsistência cadastral ou qualquer outro motivo,
          a assinatura poderá ser cancelada e os benefícios deixarão de ficar
          disponíveis.
        </p>
      </section>

      <section className="legal-section">
        <h2>7. Cancelamento</h2>
        <p>
          O assinante pode cancelar a assinatura pelos canais disponibilizados no
          aplicativo ou pelos canais oficiais de atendimento. O cancelamento impede
          novas cobranças recorrentes futuras, mas não altera atendimentos já
          realizados nem garante reembolso automático de ciclos já iniciados.
        </p>
        <p>
          Após o cancelamento, as mesmas condições, preço, vagas ou benefícios
          podem não estar mais disponíveis em uma futura contratação.
        </p>
      </section>

      <section className="legal-section">
        <h2>8. Reembolso</h2>
        <p>
          A única condição que permite reembolso automático da assinatura é a
          solicitação realizada em até 7 dias após uma renovação automática,
          desde que o beneficiário não tenha utilizado nenhum serviço incluso no
          plano durante esse período.
        </p>
        <p>
          Fora dessa condição, não haverá reembolso automático de valores pagos,
          inclusive em ciclos já iniciados, cancelamentos por iniciativa do
          assinante, indisponibilidade de horários específicos ou não utilização
          dos benefícios dentro do período contratado.
        </p>
        <p>
          Para análise manual de um pedido de reembolso em situação excepcional,
          o assinante poderá conversar diretamente com a Barbearia Filadelfo pelo
          WhatsApp oficial ou pessoalmente no estabelecimento.
        </p>
      </section>

      <section className="legal-section">
        <h2>9. Alterações de preço ou condições</h2>
        <p>
          Qualquer alteração de preço, benefícios, condições de uso, validade ou
          regras relevantes será comunicada ao assinante por e-mail com pelo menos
          30 dias de antecedência, para que ele possa avaliar a continuidade,
          alteração ou cancelamento da assinatura.
        </p>
      </section>

      <section className="legal-section">
        <h2>10. Limite de vagas e disponibilidade</h2>
        <p>
          As vagas dos planos são limitadas. Determinado plano pode ficar
          indisponível quando atingir o limite de assinantes, quando houver revisão
          comercial ou quando a Barbearia Filadelfo suspender novas contratações.
        </p>
      </section>

      <section className="legal-section">
        <h2>11. Uso indevido</h2>
        <p>
          O uso indevido da assinatura, incluindo tentativa de transferência para
          terceiros, fraude cadastral, duplicidade irregular de CPF, abuso de
          agendamentos, não comparecimentos recorrentes ou descumprimento destes
          termos, poderá resultar em suspensão ou cancelamento do plano.
        </p>
      </section>

      <section className="legal-section">
        <h2>12. Relação com outros termos</h2>
        <p>
          Estes termos complementam os Termos de Uso e a Política de Privacidade da
          Barbearia Filadelfo. Em caso de conflito envolvendo especificamente a
          assinatura Clube Filadelfo, prevalecem as condições desta página.
        </p>
      </section>

      <section className="legal-section">
        <h2>13. Entre em contato</h2>
        <p>
          Em caso de dúvidas sobre contratação, cobrança, cancelamento ou uso do
          Clube Filadelfo, entre em contato pelo e-mail{' '}
          <a href="mailto:contato@barbeariafiladelfo.com.br">
            contato@barbeariafiladelfo.com.br
          </a>
          .
        </p>
      </section>
    </div>
  );
}

export default ClubeFiladelfoTerms;
